export default __webpack_public_path__ + "static/media/young_coconut_juice_thumbnail.301cbe3e.JPG";